<template>
    <div>
        <component
            :is="footerComponent"
            v-if="preFooter?.canonicalUid && preFooterContent?.id"
            :pre-footer="preFooterContent"
            :entry="preFooterContent"
        />
    </div>
</template>

<script setup>
    const { query } = useGraphQL()

    const { digistormSettings, appId } = storeToRefs(useGlobalStore())
    const { entry } = storeToRefs(useEntryStore())

    const preFooter = computed(() => {
        return first(entry.value?.preFooter)
    })

    const data = ref(null)
    const preFooterTypeQuery = ref(null)

    const preFooterType = computed(() => {
        return digistormSettings.value.preFooterType
    })

    // Import custom components
    const customComponents = await import(`~/custom/${appId.value}/index.js`)
        .catch(() => {
            return null
        })

    const preFooterContent = computed(() => {
        return get(data.value, 'ds_PreFooterEntries.0', {})
    })

    const footerComponent = computed(() => {
        if (customComponents?.default && preFooterType.value === 'pre-footer-custom') {
            return customComponents?.default?.PreFooter
        }

        return defineAsyncComponent(() =>
            import(`./${ digistormSettings.value.preFooterType }/pre-footer.async.vue`)
        )
    })

    if (customComponents?.default && preFooterType.value === 'pre-footer-custom') {
        if (customComponents?.default?.PreFooterQuery) {
            preFooterTypeQuery.value = customComponents?.default?.PreFooterQuery
        }
    } else {
        // check the pre footer type and dynamically import the query from queries/pre-footers/{preFooterType}.ts
        preFooterTypeQuery.value = await import(`~/queries/pre-footers/${preFooterType.value}.ts`).then((q) => {
            return q.default
        })
            .catch(async () => {
                return (await import('~/queries/pre-footers/PreFooter.ts')).default
            })
    }

    onMounted(() => {
        nextTick(() => {
            let preFooterQuery = `
                query preFooters($canonicalUid: [String]) {
                    ds_PreFooterEntries(uid: $canonicalUid) {
                        ${preFooterTypeQuery.value}
                    }
                }
            `
            
            // temp fix to get pre-footer-layout content working
            if (preFooterType.value === 'pre-footer-layout') {
                preFooterQuery = preFooterTypeQuery.value
            } 

            query({
                query: preFooterQuery,
                variables: {
                    canonicalUid: preFooter.value?.canonicalUid,
                },
                key: `pre-footer-${preFooter.value?.canonicalUid}`,
                server: false,
            })
                .then((response) => {
                    data.value = response
                })
        })
    })

</script>
